const initialState = {
	list: {
		results: [],
		pageNo: 1
	},
	csrfToken: '',
	expiryDate: ''
};
export default (state = initialState, action) => {
	switch (action.type) {
		case 'SET_DISCOUNT_LIST': {
			return {
				...state,
				list: { ...action.payload }
			};
		}
		case 'OPEN_SLIDER': {
			state[action.payload.type] = {
				open: true,
				data: action.payload.data,
				extraOptions: action.payload.extraOptions
			};
			return state;
		}
		case 'CLOSE_SLIDER': {
			state[action.payload.type] = {
				...state[action.payload.type],
				open: false,
				data: null,
				extraOptions: null
			};
			return state;
		}
		case 'SET_CSRF_TOKEN': {
			return {
				...state,
				csrfToken: action.payload.csrfToken,
				expiryDate: action.payload.expiryDate
			};
		}
		default: {
			return {
				...state
			};
		}
	}
};
